// export const baseUrl = process.env.REACT_APP_MIDDLEWARE_URL;
export const baseUrl = (window._env_?.REACT_APP_MIDDLEWARE_URL || process.env.REACT_APP_MIDDLEWARE_URL);
// export const kbHome = process.env.REACT_APP_BILLBOX_BASE_URL;
export const kbHome = (window._env_?.REACT_APP_BILLBOX_HOME || process.env.REACT_APP_BILLBOX_HOME);
export const successCode = 200;
export const createSuccessCode = 201;
export const bulkdProcessorBaseUrl = (window._env_?.REACT_APP_BULK_PROCESSOR_BASE_URL || process.env.REACT_APP_BULK_PROCESSOR_BASE_URL);
